import { RouteObject } from "react-router";

import { convertRouteModule } from "../../../../lib/routing";

export const trendRoutes: Array<RouteObject> = [
  {
    path: "*",
    id: "trend",
    lazy: async () => convertRouteModule(await import("./index")),
    children: [
      { path: ":medium?", lazy: async () => convertRouteModule(await import("./application")) },
    ],
  },
];
